/*** IMPORTS FROM imports-loader ***/
var loadTerrific = require("bootstrap/load-terrific");
var Tc = loadTerrific.default;
(function() {
var window = this;
var window = (window || {});
window.Tc = Tc;

(function (Tc, $, SCS, debug) {
	'use strict';

	/**
	 * Header module implementation.
	 *
	 * @author Rami Attallah & Dave Talamona
	 * @namespace Tc.Module
	 * @class Header
	 * @extends Tc.Module
	 */
	Tc.Module.Header = Tc.Module.extend({

		$win: $(),
		$lvl2Container: $(),
		$maxAvailableWidthElement: $(),

		width: 0,
		lessVars: {},

		isMobile: false, // indicates whether the header is in its mobile view with a burger instead of visible navigation (not the "normal" backend mobile/desktop switch)
		isSemiMobile: false, // indicates whether the header is in its semi-mobile view with a burger instead of visible navigation because the navigation items take more space then available
		isDesktop: false,

		breakPoints: {
			smallerLogoSpacing: 0,
			smallerTextSpacing: 0,
			smallerText: 0,
			semiMobile: 0
		},

		on: function (callback) {
			var mod = this;

			// init module-globals
			mod.$win = $(window);
			mod.$lvl2Container = mod.$ctx.find('.scsh-dynamic');
			mod.$maxAvailableWidthElement = mod.$ctx.find('.scsh-lvl1-container');
			mod.width = mod.$maxAvailableWidthElement.width();
			mod.lessVars = SCS.utils.getLessVars(mod.$ctx) || { mobile: { breakpoint: 768 } };
			mod.breakPoints.semiMobile = Number(mod.lessVars.mobile.breakpoint);

			if (!$('body.is-mobile').length) {
				// only init the responsive parts if we're not in NEVIS forced mobile mode -> there the desktop clientlib is missing and some of the new headers parts relies on it
				mod.initResponsiveness();
			} else {
				mod.isMobile = true;
				mod.$ctx.addClass('scsh-mobile');
				debug.log('Tc.Module.Header > forced mobile mode (non-responsive)');
			}
			mod.$ctx.addClass('is-initialized');

			mod.initMddHeight();

			mod.$ctx.find('.scsh-icon-menu > li > a').on('click', function (event) {
				var $this = $(this),
					item = $this.parent(),
					isActivate,
					burgerNav;

				// deactivate other active items
				{
					// other LIs on the same level
					item.siblings('.active').removeClass('active');

					// other lists on the same level with active LIs (eg. for scsh-icon-menu vs. item-menu)
					item.parent().siblings().children('.active').removeClass('active');
				}

				item.toggleClass('active');

				// burger menu
				if (item.hasClass('burger')) {
					isActivate = item.hasClass('active');
					burgerNav = mod.$ctx.find('.menu-items');
					if (isActivate) {
						burgerNav.find('.scsh-search-hidden-menus').removeClass('scsh-search-hidden-menus');
						mod.$win.scrollTop(0);
						burgerNav.scrollTop(0);
					}
					burgerNav.toggleClass('active', isActivate);
					$this.blur();

					if (mod.isMobile) {
						mod.$ctx.toggleClass('is-sticky', isActivate);
						debug.log('Tc.Module.Header > is-sticky', isActivate);
						if (isActivate) {
							// Wait a bit until the menu slides in a bit and has enough place,
							// otherwise browser will scroll to focus the search box into view ...
							setTimeout(function() {
								mod.$ctx.find('.modSiteSearch.skinSiteSearchMobileMenu input[name=q]').trigger('click').trigger('focus');
								mod.$ctx.find('.skinFusionSearchMobileMenu input[data-name=query]').trigger('click').trigger('focus');
							}, 250);
						}
					}

					if (isActivate && mod.isSemiMobile) {
						// set the menu to fixed width, based on the first level of entries, because it should no change its width anymore, once its opened:
						// PORTAL-9064
						setTimeout(function () {
							burgerNav.css('width', burgerNav.width() + 2 + 'px'); // plus 2 because else its not enough
						}, 6);
					}
				}

				// This makes the MDD animate promptly and makes click tracking asynchronous.
				if (!item.data('dont-prevent-click')) {
					event.preventDefault();
				}
			});

			// close MDD and icon-tools (search, etc.) on click outside
			$(document).on('click', function (e) {
				if (!$(e.target).closest('.scsh-icon-menu, .menu-items').length && !($('.scs-sitesearchcontainer-plus').length || $('.scs-sitesearchcontainer').length)) {
					mod.$ctx.find('.scsh-icon-menu > li.active, .menu-items > li.scsh-has-subnav.active').not(':has(> .modFlyout)').find('> a, .lvl1-item a').trigger('click');
				}
			});

			mod.$ctx.find('.scsh-lvl2-container.scsh-has-child-pages h1').on('click', function () {
				if (mod.isMobile) {
					$(this).toggleClass('active').closest('.scsh-lvl2-container').find('.scsh-lvl2-navi').toggleClass('active');
				}
			});

			// make dev life easier
			if (location.search.match(/\bdebugmenu\b/)) {
				mod.$ctx.find('.scsh-icon-menu .burger > a').click();
				mod.$ctx.find('.menu-items .lvl1-item:eq(0) > a').click();
			}

			mod.initTrackingLinkName();

			mod.initLanguageSwitch();

			callback();
		},

		initLanguageSwitch: function () {
			var mod = this,
				$links = mod.$ctx.find('.scsh-language-switch-list a');

			if (!$links.length) {
				return;
			}
			function updateLinks() {
				$links.each(function () {
					this.hash = location.hash;
					mod.log('updated hash', this.href);
				});
			}
			$(window).on('hashchange', updateLinks);
			updateLinks();
		},

		setHeaderTitle: function(newTitle) {
			this.$ctx.find('.scsh-lvl2-container h1').text(newTitle);
		},

		initTrackingLinkName: function () {
			var mod = this;
			mod.findTrackingLinks().on('click', mod.handleTrackingLinkClick);
			mod.$ctx.find('.secondary-navigation .link .aTag').on('click', function(e) {
				var isSticky = !!$(this).parents('.scsh-dynamic.is-sticky').length;
				var $mddLvl1Link = $(this).closest('.scsh-has-subnav').find('h2 a'),
					mddLvl1 = $mddLvl1Link.data('tracking-link-name') || $mddLvl1Link.text() || 'mddLvl1',
					mddLvl2 = $.trim(mddLvl1) + '_' + ( $(this).data('track-linkname') || $.trim($(this).find('h4').text()));

				window.scsHeader.siteCatalyst.trackClick(this, e, mddLvl2, 'MDD' + (isSticky ? '-sticky' : ''));
			});
		},
		findTrackingLinks: function () {
			var mod = this;
			return mod.$ctx.find('.secondary-navigation li a.linklist');
		},
		handleTrackingLinkClick: function (e) {
			var isSticky = !!$(this).parents('.scsh-dynamic.is-sticky').length;
			var $mddLvl1Link = $(this).closest('.scsh-has-subnav').find('h2 a'),
				mddLvl1 = $mddLvl1Link.data('tracking-link-name') || $mddLvl1Link.text() || 'mddLvl1',
				mddLvl2 = $(this).parents('.column').find('a').data('track-linkname') || $(this).parents('.column').find('h4:first, .modPromoBadge').text() || 'mddLvl2',
				mddLvl3 = $.trim(mddLvl1) + '_' + $.trim(mddLvl2) + '_' + ($(this).data('tracking-link-name') || $(this).text());
			window.scsHeader.siteCatalyst.trackClick(this, e, mddLvl3, 'MDD' + (isSticky ? '-sticky' : ''));
		},

		initResponsiveness: function () {
			var mod = this;

			// pre-processor for following resize-listeners
			mod.$win.on('resize', function () {
				mod.width = mod.$maxAvailableWidthElement.width();

				if (!mod.isMobile && mod.width <= Number(mod.lessVars.mobile.breakpoint)) {
					mod.$win.trigger('scsh-responsive-switch').trigger('scsh-responsive-switch-mobile');

					mod.$ctx.removeClass('scsh-semi-mobile scsh-desktop').addClass('scsh-mobile');

					mod.isMobile = true;
					mod.isSemiMobile = false;
					mod.isDesktop = false;
				} else if (!mod.isSemiMobile && mod.width > Number(mod.lessVars.mobile.breakpoint) && mod.width < mod.breakPoints.semiMobile) {
					mod.$win.trigger('scsh-responsive-switch').trigger('scsh-responsive-switch-semiMobile');

					mod.$ctx.removeClass('scsh-mobile scsh-desktop').addClass('scsh-semi-mobile');

					// move semi mobile menu to the right edge of the icons
					mod.$ctx.find('.menu-items').css('right', 4 - 20 - mod.$ctx.find('.scsh-icon-menu').width());

					mod.isMobile = false;
					mod.isSemiMobile = true;
					mod.isDesktop = false;
				} else if (!mod.isDesktop && mod.width >= mod.breakPoints.semiMobile) {
					mod.$win.trigger('scsh-responsive-switch').trigger('scsh-responsive-switch-desktop');

					mod.$ctx.removeClass('scsh-mobile scsh-semi-mobile').addClass('scsh-desktop');

					mod.isMobile = false;
					mod.isSemiMobile = false;
					mod.isDesktop = true;
				}
				debug.log('Tc.Module.Header > initResponsiveness', mod.width, mod.isDesktop ? 'isDesktop' : mod.isSemiMobile ? 'isSemiMobile' : mod.isMobile ? 'isMobile' : '?');

				if (window.scsHeader && window.scsHeader.positionToolbarFiller) {
					// update legacy header toolbar
					window.scsHeader.positionToolbarFiller();
				}
			}).trigger('resize');

			// initialization that must be done when the header is NOT in mobile view
			{
				var doInitializationsWhenNotMobile = function () {
					mod.measureResponsiveBreakpoints();

					if (mod.$lvl2Container.length && mod.$lvl2Container.find('.scsh-lvl2-navi > li').length) {
						// lvl2 area is present and has nav-items -> init handling of item-overflow
						mod.initLvl2OverflowBreak();

						// listener for click on overflow-nav dropdown
						mod.$ctx.find('.scsh-lvl2-overflow-container > a').on('click', function () {
							var overflowContainer = mod.$ctx.find('.scsh-lvl2-overflow-container');

							overflowContainer.trigger('scsh-flyout-open', [function () {
								overflowContainer.removeClass('scsh-active');
							}]);

							overflowContainer.addClass('scsh-active');
						});
					}

					// init stickiness of lvl2 navigation
					if (mod.$lvl2Container.length) {
						mod.initStickiness();
					}

					mod.$win.trigger('resize').trigger('scroll');
					mod.afterMeasure();
				};

				// mobile view is active -> it's not possible to measure because the mediaquery prevents it -> wait till another view is active
				if (mod.isMobile) {
					mod.$win.on('scsh-responsive-switch', function measureOnSwitchFromMobileView() {
						// stop watching
						mod.$win.off('scsh-responsive-switch', measureOnSwitchFromMobileView);

						doInitializationsWhenNotMobile();
					});
				}

				// mobile view is not active -> measurements can be done now
				else {
					doInitializationsWhenNotMobile();
				}
			}
		},

		measureResponsiveBreakpoints: function () {
			var mod = this;

			// clone header for measurement without having flickering on the original one
			var clonedHeader = mod.$ctx.clone()
				.attr('data-ignore', true).attr('data-ignore-descendants', true) // prevent init of terrific modules
				.css('opacity', 0) // hide it from the user
				.css('position', 'absolute').css('width', '100%') // force full with like the original relative positioned one
				.removeClass('scsh-mobile scsh-semi-mobile').addClass('scsh-desktop') // set it to desktop view
				.insertAfter(mod.$ctx);

			var iconNavi = clonedHeader.find('ul.scsh-icon-menu'),
				textNavi = clonedHeader.find('ul.menu-items'),
				lastTextItem = textNavi.children(':visible:last'),
				spaceNeededNormal = 0,
				spaceNeededSmallerLogoDistance = 0,
				spaceNeededSmallerTextSpacing = 0,
				spaceNeededSmallerText = 0,
				unshrinkableSpace = (2 * Number(mod.lessVars.desktop.edgeSpacing)) + iconNavi.outerWidth(true),
				getTextSpace = function () {
					// do not measure the ULs (textNavi) with because it can be bigger then the space needed by the items
					if (!lastTextItem.length) {
						return 0;
					}
					return lastTextItem.offset().left + lastTextItem.width() - textNavi.offset().left;
				};

			// measure normal state
			spaceNeededNormal = unshrinkableSpace + Number(mod.lessVars.desktop.logoTotalWidth.big) + getTextSpace();
			if (spaceNeededNormal > Number(mod.lessVars.mobile.breakpoint)) {
				mod.breakPoints.smallerLogoSpacing = spaceNeededNormal;
			}

			// measure with shrinked logo distance (shrinking step 1)
			// adding 'lvl1-small-logo-spacing' class is not necessary since we have the value as less var
			spaceNeededSmallerLogoDistance = unshrinkableSpace + Number(mod.lessVars.desktop.logoTotalWidth.small) + getTextSpace();
			if (spaceNeededSmallerLogoDistance > Number(mod.lessVars.mobile.breakpoint)) {
				mod.breakPoints.smallerTextSpacing = spaceNeededSmallerLogoDistance;
			}

			// measure with also shrinked text spacing (shrinking step 2)
			clonedHeader.addClass('lvl1-small-text-spacing');
			spaceNeededSmallerTextSpacing = unshrinkableSpace + Number(mod.lessVars.desktop.logoTotalWidth.small) + getTextSpace();
			if (spaceNeededSmallerTextSpacing > Number(mod.lessVars.mobile.breakpoint)) {
				mod.breakPoints.smallerText = spaceNeededSmallerTextSpacing;
			}

			// measure with also shrinked text size (shrinking step 3)
			clonedHeader.addClass('lvl1-small-text');
			spaceNeededSmallerText = unshrinkableSpace + Number(mod.lessVars.desktop.logoTotalWidth.small) + getTextSpace();
			if (spaceNeededSmallerText > Number(mod.lessVars.mobile.breakpoint)) {
				mod.breakPoints.semiMobile = spaceNeededSmallerText;
			}

			clonedHeader.remove();

			mod.initLvl1OverflowBreak();
		},

		initLvl1OverflowBreak: function () {
			var mod = this;

			// switch from desktop to semiMobile
			mod.$win.on('scsh-responsive-switch-semiMobile', function () {
				if (mod.isDesktop) {
					mod.$ctx.removeClass('lvl1-animated-shrinking lvl1-small-text lvl1-small-text-spacing lvl1-small-logo-spacing');
				}
			});

			// switch from semiMobile to desktop
			mod.$win.on('scsh-responsive-switch-desktop', function () {
				if (mod.isSemiMobile) {
					mod.$ctx.addClass('lvl1-small-text lvl1-small-text-spacing lvl1-small-logo-spacing');

					// force re-rendering before appending the 'lvl1-animated-shrinking' class to prevent animations for this iteration
					mod.$ctx.width();
					mod.$ctx.addClass('lvl1-animated-shrinking');
				}
			});

			// breakpoints
			mod.$win.on('resize', function () {
				// handle desktop view with shrinked text size (shrinking step 3)
				if (mod.isDesktop && mod.breakPoints.smallerText && mod.width < mod.breakPoints.smallerText && !mod.$ctx.hasClass('lvl1-small-text')) {
					mod.$ctx.addClass('lvl1-animated-shrinking lvl1-small-text');
				} else if (mod.breakPoints.smallerText && mod.width >= mod.breakPoints.smallerText && mod.$ctx.hasClass('lvl1-small-text')) {
					mod.$ctx.removeClass('lvl1-small-text');
				}

				// handle desktop view with shrinked text spacing (shrinking step 2)
				if (mod.isDesktop && mod.breakPoints.smallerTextSpacing && mod.width < mod.breakPoints.smallerTextSpacing && !mod.$ctx.hasClass('lvl1-small-text lvl1-small-text-spacing')) {
					mod.$ctx.addClass('lvl1-animated-shrinking lvl1-small-text-spacing');
				} else if (mod.breakPoints.smallerTextSpacing && mod.width >= mod.breakPoints.smallerTextSpacing && mod.$ctx.hasClass('lvl1-small-text-spacing')) {
					mod.$ctx.removeClass('lvl1-small-text-spacing');
				}

				// handle desktop view with shrinked logo spacing (shrinking step 1)
				if (mod.isDesktop && mod.breakPoints.smallerLogoSpacing && mod.width < mod.breakPoints.smallerLogoSpacing && !mod.$ctx.hasClass('lvl1-small-text-spacing lvl1-small-logo-spacing')) {
					mod.$ctx.addClass('lvl1-animated-shrinking lvl1-small-logo-spacing');
				} else if (mod.breakPoints.smallerLogoSpacing && mod.width >= mod.breakPoints.smallerLogoSpacing && mod.$ctx.hasClass('lvl1-small-logo-spacing')) {
					mod.$ctx.removeClass('lvl1-small-logo-spacing');
				}
			});
		},

		initLvl2OverflowBreak: function () {
			var mod = this,
				nav = mod.$ctx.find('.scsh-lvl2-navi'),
				overflowNav = mod.$ctx.find('.scsh-lvl2-overflow-navi'),
				overflowContainer = mod.$ctx.find('.scsh-lvl2-overflow-container'),
				maxXPosElement = nav.closest('.scsh-lvl2-container'),
				firstNavItem = nav.children().first(),
				firstNavItemSpacingToTitle = firstNavItem.css('margin-left').replace('px', ''),
				lastHeaderWidth = 0,
				overflowNavVisible = false,
				mobilizedItems = $();

			// store each items outer-with inclusive margin
			nav.children().each(function () {
				var li = $(this);

				li.data('width', li.outerWidth(true));
			});

			mod.$win.on('resize', function () {
				var headerWidth = mod.width,
					navItems = nav.children();

				// do not do anything if (complete) mobile view is active
				if (mod.isMobile) {
					if (!mobilizedItems.length) {
						mobilizedItems = overflowNav.children().appendTo(nav);
					}
					return;
				} else if (mobilizedItems.length) {
					mobilizedItems.appendTo(overflowNav);
					mobilizedItems = $();
				}

				// screen got smaller -> check for moving items to overflow nav
				if ((headerWidth < lastHeaderWidth || !lastHeaderWidth) && navItems.length > 1) {
					var maxXPos = Math.round(maxXPosElement.offset().left + maxXPosElement.width()),
						lastElement = (overflowNavVisible ? overflowContainer : navItems.last());

					// move all but the first item into overflow navi (ignore forst one to prevent just having the overflow navi there)
					while (navItems.length > 1 && Math.floor(lastElement.offset().left + lastElement.outerWidth()) > maxXPos) {
						var lastNavItem = navItems.last();

						// move to overflow-list
						lastNavItem.prependTo(overflowNav);

						// remove the last item from the set
						navItems = navItems.not(lastNavItem);

						if (!overflowNavVisible) {
							overflowContainer.addClass('is-visible');
							overflowNavVisible = true;
							lastElement = overflowContainer;
						}
					}
				}

				// screen got bigger -> check for moving items back to normal nav
				else if (headerWidth > lastHeaderWidth && overflowNavVisible) {
					var availableSpace = Math.floor(firstNavItem.offset().left - firstNavItemSpacingToTitle - nav.offset().left),
						overflowItems = overflowNav.children(),
						firstOverflowElement = overflowItems.first();

					while (overflowItems.length && availableSpace >= firstOverflowElement.data('width')) {
						// move back to normal-list
						firstOverflowElement.appendTo(nav);

						// reduce available space by the moved elements width
						availableSpace -= firstOverflowElement.data('width');

						// get new first item in overflow-nav
						overflowItems = overflowItems.not(firstOverflowElement); // remove the first item from the set
						firstOverflowElement = overflowItems.first(); // get the new first item

						if (!overflowItems.length) {
							overflowContainer.removeClass('is-visible');
							overflowNavVisible = false;
						}
					}
				}

				lastHeaderWidth = headerWidth;
			});
		},

		initStickiness: function () {
			var mod = this,
				stickyElement = mod.$lvl2Container, // if you want to make LVL1 sticky again when LVL2 is not present then check GIT history - this was removed with story PORTAL-8984
				stickyPos = stickyElement.offset().top,
				isSticky = false,
				placeholderElement = (mod.$lvl2Container.hasClass('is-floating') ? $() /* none - is already absolute */ : mod.$ctx.find('.scsh-static')),
				makeNormal = function () {
					stickyElement.removeClass('is-sticky');
					stickyElement.find('.modImageAnimation').data('width', 39);

					if (placeholderElement.length) {
						placeholderElement.css('margin-bottom', '');
					}

					isSticky = false;
				};

			// check if stickiness must be changed
			mod.$win.on('scroll', function () {
				// do not do anything if mobile view or edit mode is active
				var isEditMode = require('lib/util/helpers').isEditMode();
				if (mod.isMobile || mod.isSemiMobile || isEditMode) {
					return;
				}

				//noinspection JSValidateTypes
				var scrollPos = mod.$win.scrollTop();

				// make sticky
				if (!isSticky && scrollPos > stickyPos) {
					if (placeholderElement.length) {
						placeholderElement.css('margin-bottom', stickyElement.outerHeight(true) + 'px');
					}

					stickyElement.addClass('is-sticky');
					stickyElement.find('.modImageAnimation').data('width', 24);

					isSticky = true;
				}

				// make normal
				else if (isSticky && scrollPos <= stickyPos) {
					makeNormal();
				}
			}).trigger('scroll');

			// remove stickiness when switching to mobile
			mod.$win.on('scsh-responsive-switch-mobile scsh-responsive-switch-semiMobile', function () {
				if (isSticky) {
					makeNormal();
				}
			});

			// restore stickiness if needed when switching from mobile to another view
			mod.$win.on('scsh-responsive-switch-desktop', function () {
				if (mod.isMobile || mod.isSemiMobile) { // switching from mobile to another view
					window.setTimeout(function () {
						mod.$win.trigger('scroll');
					}, 10);
				}
			});
		},

		afterMeasure: function () {
			var mod = this;

			if (window.navigator.userAgent.indexOf('Safari') > -1) {
				mod.$ctx.find('.menu-items > li').each(function (i, item) {
					item.style.transform = 'scale(1)';
					item.style.webkitTransform = 'scale(1)';
					window.setTimeout(function () {
						item.style.transform = '';
						item.style.webkitTransform = '';
					}, 0);
				});
			}
		},

		initMddHeight: function () {
			var mod = this,
				items = mod.$ctx.find('.menu-items > .scsh-has-subnav'),
				sizedItems = $(),
				imagesLoaded = false,
				resizeTimeout = null,
				setItemMaxHeight = function () {
					if (this.length && !SCS.utils.isIE11()) {
						this.data(
							'maxHeightStyle',
							$('<style> .modHeader .scsh-has-subnav:nth-child(' + (this.index() + 1) + ').active .secondary-navigation { max-height: ' + this.find('.scsh-mdd-content').height() + 'px !important; } </style>')
								.appendTo(this)
						);
						sizedItems = sizedItems.add(this);
					}
				};

			items.children('.lvl1-item').on('click', function (event) {
				var item = $(this).parent();

				// deactivate other active items
				{
					// other LIs on the same level
					item.siblings('.active').removeClass('active');

					// other lists on the same level with active LIs (eg. for scsh-icon-menu vs. item-menu)
					if (!mod.isMobile && !mod.isSemiMobile) {
						item.parent().siblings().children('.active').removeClass('active');
					}
				}

				item.toggleClass('active');

				// measure and set MDDs proper height (for closing animation and further opening animations)
				{
					window.clearTimeout(item.data('measureHeightTimeoutId'));
					if (!item.data('maxHeightStyle') && item.hasClass('active')) {
						// use timeout time to wait until opening animation is done (animation time is 300ms)
						// store timeout ID to prevent measurement when MDD is closed again before properly opened
						item.data('measureHeightTimeoutId', window.setTimeout($.proxy(setItemMaxHeight, item), 500));
					}
				}

				// This makes the MDD animate promptly and makes click tracking asynchronous.
				event.preventDefault();

				// Tracking event should be called after openning or closing the MDD
				var isSticky = !!$(this).parents('.scsh-dynamic.is-sticky').length;
				window.scsHeader.siteCatalyst.trackClick(this, event, $(this).find('a').data('tracking-link-name') || $(this).text(), 'MDD' + (isSticky ? '-sticky' : ''));

				//lazy load images
				if(SCS.lazyLoadImages && !imagesLoaded){
					SCS.lazyLoadImages(mod.$ctx);
					imagesLoaded = true;
				}

			});

			mod.$win.on('resize', function () {
				// use timeout to throttle
				window.clearTimeout(resizeTimeout);
				resizeTimeout = window.setTimeout(function () {
					if (sizedItems.length) {
						// clear all set heights
						sizedItems.each(function () {
							($(this).data('maxHeightStyle') || $()).remove();
						});
						sizedItems.removeData('maxHeightStyle');
						sizedItems = $();

						// set height of the currently open MDD
						setItemMaxHeight.call(items.filter('.active'));
					}
				}, 10);
			});
		}
	});
}(window.Tc, window.scsHeaderJQuery, window.SCS, window.debug));

}.call(window));


//////////////////
// WEBPACK FOOTER
// ./clientlibs/js/etc/designs/header/clientlibs/responsive/js/modules/Tc.Module.Header.js
// module id = 362
// module chunks = 0